import {
  faAngleLeft,
  faChevronDown,
  faEye,
  faPen,
  faPlus,
  faTrashCan,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Modal, Table } from "react-bootstrap";
import "./Table.css";
import Add_offcanvas from "./add_offcanvas/Add_offcanvas";
import Edit_offcanvas from "./edit_offcanvas/Edit_offcanvas";
import rejectAnimation from "../../../../../animation/success_lottie/Reject_lottie.json";
import Success_modal from "../../../../../common_components/common_modal/success_modal/Success_modal";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../../../utils/IDS";
import CustomPaginate from "../../../../../../common/custompaginate/CustomPaginate";
import { Delete } from "../../../../../..../../../features/admin/masters/country/Slice";
import { useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/common";
import { Context } from "../../../../../../utils/context";

const WhyChooseUs = () => {
  const { isAllow: permissions, usertype } = useContext(Context);

  const {
    contact_us,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  } = IndexUse();

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [modalRejectShow, setModalRejectShow] = useState(false);
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showEditCanvas, setShowEditCanvas] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const courseRef = useRef(null);
  const handleStatusSelect = (status) => {
    console.log(status);
    setOpenStatus(false);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleDelete = async () => {
    const success = await deleteData(deleteId);

    if (success) {
      setShowDeleteModal(false);
      setDeleteId(null);
      setSuccess(true);
    } else {
      setErr(true);
    }
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (courseRef.current && !courseRef.current.contains(e.target))
        setOpenStatus(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>
      <section className="Collage_intern application_section">
        <div className="serach_header">
          {/* Search */}
          {/* <InputGroup className="search_box">
            <Form.Control
              placeholder="Search Country"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup> */}
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Contact Us list</h5>

          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>Message</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                {contact_us?.data?.length > 0 ? (
                  contact_us?.data?.map((val, index) => (
                    <tr key={index}>
                      <td>
                        {(contact_us?.current_page - 1) * contact_us?.per_page +
                          index +
                          1}
                      </td>

                      <td>{val?.name}</td>
                      <td>{val?.email}</td>
                      <td>{val?.contact_no}</td>
                      <td>{val?.message}</td>
                      <td>
                        {val?.createdAt
                          ? new Date(val.createdAt).toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center fw-bold">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CustomPaginate
              currentPage={contact_us?.current_page}
              totalPages={contact_us?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>
      <Add_offcanvas
        show={showAddCanvas}
        setShow={setShowAddCanvas}
        setSuccess={setSuccess}
        setErr={setErr}
        setShowRejectModal={setShowRejectModal}
        handleClose={() => setShowAddCanvas(false)}
      />

      <Edit_offcanvas
        show={showEditCanvas}
        setShow={setShowEditCanvas}
        setSuccess={setSuccess}
        setErr={setErr}
        setShowRejectModal={setShowRejectModal}
        handleClose={() => setShowEditCanvas(false)}
      />

      <Success_modal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        message_text="Application Rejected"
        animationData={rejectAnimation}
      />

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this country?</Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>

          <Button
            variant="danger"
            onClick={handleDelete} // ✅ THIS IS WHERE YOU CALL IT
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WhyChooseUs;
